import React, { Component } from 'react'
import { Form, Col, Button } from 'react-bootstrap'
import TogglePanel from '../TogglePanel'
import { ServiceDataModel } from '../OrderModels'

export interface SelectServiceTogglePanelProps {
  title: string,
  data: ServiceDataModel,
  collapsibleId: string,
  disabled: boolean,
  open?: boolean,
  onClose: () => void,
  onSubmit: () => void,
  onValidate: (data: ServiceDataModel) => boolean
}

interface SelectServiceTogglePanelState {
  open: boolean
}

export default class SelectServiceTogglePanel extends Component<SelectServiceTogglePanelProps, SelectServiceTogglePanelState> {
  constructor(props: SelectServiceTogglePanelProps) {
    super(props)

    this.state = { open: props.open || false }
  }

  onSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    this.props.onSubmit()
    this.setOpen(false)
  }

  onHeaderClick = () => this.state.open ? null : this.setOpen(true)

  onCloseClick = () => {
    this.setOpen(false)
    this.props.onClose()
  }

  setOpen = (open: boolean) => this.setState({open: open}) // Closing clears all entered data

  render() {
    const { title, disabled, onValidate, collapsibleId, data } = this.props
    const isValid = onValidate(data)
    const header = <div>{title}<span className="float-right">+</span></div>
    return (
      <TogglePanel  collapsibleId={collapsibleId}
                    header={header}
                    onHeaderClick={this.onHeaderClick}
                    isOpen={this.state.open}
                    isDisabled={disabled || (!!this.props.open && !!this.props.open !== this.state.open)}>
        <Form onSubmit={this.onSubmit}>
          {this.props.children}
          <Form.Row>
            <Col>
              {!this.props.open && <Button type="reset" variant="secondary" size="sm" className="fixed-w5" onClick={this.onCloseClick}>CANCEL</Button>}
              <Button type="submit" variant="primary" size="sm" className="fixed-w5 float-right" disabled={!isValid}>ADD</Button>
            </Col>
          </Form.Row>
        </Form>
      </TogglePanel>
    )
  }
}
